import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      { path: '', component: HomeComponent },
      //{ path: 'provider-public', component: DealerPublicComponent },
      //{ path: 'alerts', component: AlertsComponent },
      //{ path: 'about', component: AboutComponent },
      //{ path: 'services', component: ServicesComponent },
      //{ path: 'contact', component: ContactComponent },
      //{ path: '', redirectTo: '/admin/home', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
